import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  buildDeniedPermissions,
  buildPermissions,
  StaffPermissionMap,
  staffPermissionSchema
} from '../schemas/staff-permission.schema';
import { StaffService } from '../api/staff.service';

@Injectable({
  providedIn: 'root'
})
export class StaffPermissionsService {
  private permissionsSource$ = new BehaviorSubject<StaffPermissionMap>(buildDeniedPermissions());

  public permissions$: Observable<StaffPermissionMap> = this.permissionsSource$.asObservable();

  /** Every permission in staffPermissionSchema, resolved for the logged-in staff member. */
  public get permissions(): StaffPermissionMap {
    return this.permissionsSource$.value;
  }

  constructor(private staffService: StaffService) {}

  public updateFromLoggedInStaff(): void {
    const role = this.staffService.role;

    this.permissionsSource$.next(
      buildPermissions(permission => {
        return !!role && staffPermissionSchema[permission].indexOf(role) !== -1;
      })
    );
  }
}
